import React from 'react';
import JitterEditor from './JitterEditor'
import FunctionEditor from './FunctionEditor'
import RandomNumberEditor from './RandomNumberEditor'
import RandomBooleanEditor from './RandomBooleanEditor'

function createEditor( updater, props ) {

  if ( updater == null ) {
    return null;
  }
  
  props = props || { }
  props.updater = updater
  switch ( updater.type ) {
    case JitterEditor.TYPE: return <JitterEditor {...props} />
    case FunctionEditor.TYPE: return <FunctionEditor {...props} />
    case RandomNumberEditor.TYPE: return <RandomNumberEditor {...props} />
    case RandomBooleanEditor.TYPE: return <RandomBooleanEditor {...props} />
    default: {}
  }
  return <div /> 
}

module.exports = {
  createEditor
}
